import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanDeactivate,
} from '@angular/router';
import { Storage } from '@ionic/storage';

@Injectable()
export class UnAuthGuard implements CanActivate {
  constructor(private router: Router, private storage: Storage) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const token = await this.storage.get('token');

    if (token) {
      this.router.navigate(['/tabs/tab1']);
      return false;
    }

    return true;
  }
}
